// Module
var code = "<a ng-href={{$ctrl.url}} target=_blank ng-click=$event.stopPropagation()> <i class=\"fab fa-twitter-square\"></i> </a> ";
// Exports
module.exports = code;